import React, { useState, useRef } from "react";
import { SettingRow } from "../SettingRow";
import { Checkbox } from "../../../../../../common/components/input/Checkbox";
import { Modal } from "@truevault/aquilo";
import { useField } from "react-final-form";

export const ConsentBannerAllowCSSOverridesRow = () => {
  const [showWarningModal, setShowWarningModal] = useState(false);
  const { input } = useField("allowCSSOverrides", { type: "checkbox" });
  const previousValueRef = useRef(input.value);

  const handleAfterChange = (checked: boolean) => {
    // If trying to enable (check the box from false to true), show the warning modal and revert the change
    if (checked && !previousValueRef.current) {
      setShowWarningModal(true);
      // Revert the change immediately
      input.onChange(false);
    } else {
      // Update the ref for the next change
      previousValueRef.current = checked;
    }
  };

  const handleConfirm = () => {
    input.onChange(true);
    previousValueRef.current = true;
    setShowWarningModal(false);
  };

  const handleCancel = () => {
    setShowWarningModal(false);
  };

  return (
    <>
      <SettingRow
        maxWidthChildren={true}
        title="Allow Custom Styles"
        helpText="Enable this setting to allow your developers to apply custom styles to the consent banner on your website."
      >
        <Checkbox
          field="allowCSSOverrides"
          label="Let custom styles affect the banner"
          afterChange={handleAfterChange}
        />
      </SettingRow>

      {showWarningModal && (
        <Modal
          title="A note about consent banner styles"
          body={
            <>
              TrueVault's consent banners are configured to help you comply with privacy laws and to
              avoid employing{" "}
              <a
                href="https://knowledge.truevault.com/article/256-cookie-banner-design"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 hover:text-primary-700 underline"
              >
                dark patterns
              </a>
              , which can be considered a privacy violation. If you choose to alter the design of
              your banner in a way that falls outside of our recommendations, you assume all risk of
              any enforcement or legal action that occurs as a result.
            </>
          }
          alignText="left"
          closeButton={true}
          onClose={handleCancel}
          firstButton="Cancel"
          secondButton="I Understand"
          firstButtonColor="tertiary"
          secondButtonColor="primary"
          alignButton="right"
          onFirstButtonClick={handleCancel}
          onSecondButtonClick={handleConfirm}
          showOverlay={true}
          closeOnOverlayClick={false}
        />
      )}
    </>
  );
};
